import { ErrorBaseData } from '.'

export const cepErrors: Record<string, ErrorBaseData> = {
  CepInvalidException: {
    message: 'CEP não encontrado',
    description: 'Não foi possível encontrar a cidade pelo CEP. Verifique as informações e tente novamente',
  },
}
